import React, { useEffect, useRef, useState } from "react";
import AppLayout from "../layouts/AppLayout";
import IRouterComponentProps from "../../models/IRouterComponentProps";

import JewelleryProductAuction from "./component/JewelleryProductAuction";
import DiamondProductAuction from "./component/DiamondProductAuction";
import { oAuth } from "../../routes/basic/BasicAppRouter";
import { useHistory, useParams } from "react-router";
import AuthService from "../auth/AuthService";
import {
  annualAuctionJoinedCall,
  profileUrl,
  getTimeZones,
  advertisementUrl,
} from "../../common/config/app.endpoints";
import Alert from "../../common/elements/Alert";
import LoadingSpinner from "../../common/elements/LoadingSpinner";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  reSetIsMybids,
  reSetJwlIsMybids,
  selectedParticipateId,
  resetParticipateProductId,
} from "../../redux/slice/commanPagination/commanPaginationSlice";
import {
  setAnnualAuctionData,
  setJwlAnnualAuctionData,
} from "../../redux/slice/annual/commanAnnualSlice";
import { joinAnnualAuction } from "../../common/GenericFunctions";
import { StyledModal } from "../../common/materials/GenericStyleComponent";
import NewPassword from "../../modules/login/passwordReset/NewPassword";

import SubdomainEditProfileForm from "../profile/SubdomainEditProfileForm";
import PaddleNumberModal from "../../common/elements/PaddleNumberModal";
import { RootState } from "../../redux/reducer";
import PubSub from "pubsub-js";

interface IPendingProductProps extends IRouterComponentProps {}

let annualCategoryAuction = "Diamonds";
const ProductAuctionContainer = (props: IPendingProductProps) => {
  let history = useHistory();
  const Auth = new AuthService();
  const [isShowJewelley, setShowJewelley] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [openToast, setOpenToast] = useState<boolean>(false);
  const [showAlertMessage, setShowAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<string>("");

  const [showNewPasswordPopup, setShowNewPasswordPopup] = useState(false);
  const [isEditProfile, setIsEditProfile] = useState(false);

  const [profileData, setProfileData] = useState<any>();
  const [timeZone, setTimeZone] = useState();
  const [isPaddle, setIsPaddle] = useState<boolean>(false);

  const { auctionType } = useParams<any>();
  const dispatch: AppDispatch = useDispatch();

  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectedParticipateId(state),
  );

  useEffect(() => {
    const path = history.location.pathname.toLowerCase().replace(/\/$/, "");
    if (
      path === "/365products" ||
      path === "/365products/diamonds" ||
      path === "/365products/diamond"
    ) {
      handleComponents("DIAMODS");
    } else if (path === "/365products/jewellery") {
      handleComponents("JEWELLERY");
    }
  }, [history.location.pathname]);

  useEffect(() => {
    const init = async () => {
      localStorage.setItem("tabSelectedVal", "1");

      if (auctionType === undefined) {
        localStorage.removeItem("currentProductIdOfBidNow");
        localStorage.removeItem("currentJewelleryProductIdOfBidNow");
      }

      if (oAuth()) {
        getTimeZone();
        await getProfile();

        const defaultPasswordUpdated: any = localStorage.getItem(
          "defaultPasswordUpdated",
        );

        const isDefaultPasswordUpdated: boolean = JSON.parse(
          defaultPasswordUpdated,
        );

        const otpAuth: any = localStorage.getItem("otpAuth");
        const isOtpAuth: boolean = JSON.parse(otpAuth);

        if (isDefaultPasswordUpdated !== null) {
          if (isDefaultPasswordUpdated) {
            setShowNewPasswordPopup(false);
          } else if (isOtpAuth !== true && isDefaultPasswordUpdated === false) {
            // Check if we haven't shown it yet this session
            if (!sessionStorage.getItem("hasSeenPaddle")) {
              onOpenPaddleModal();
              sessionStorage.setItem("hasSeenPaddle", "true"); // Mark it as shown!
            }
          } else if (isOtpAuth !== true) {
            setShowNewPasswordPopup(false);
          } else {
            // Check if we haven't shown it yet this session
            if (!sessionStorage.getItem("hasSeenPaddle")) {
              onOpenPaddleModal();
              sessionStorage.setItem("hasSeenPaddle", "true"); // Mark it as shown!
            }
          }
        }
      }
    };

    init();
  }, []);

  const getTimeZone = () => {
    Auth.getRequest(getTimeZones, (status: number, response: any) => {
      if (status === 200 && response !== undefined) {
        setTimeZone(response);
      }
    });
  };

  const getProfile = async () => {
    return new Promise((resolve, reject) => {
      Auth.getRequest(profileUrl, (status: number, response: any) => {
        if (status === 200 && response !== undefined) {
          setProfileData(response);
          localStorage.setItem("isReadOnlyUser", response.readOnlyUser);
          localStorage.setItem("paddleNumber", response.paddleNumber);
          if (response.timezone) {
            localStorage.setItem("timezoneName", response.timezone.name);
          }
          localStorage.setItem(
            "defaultPasswordUpdated",
            response.defaultPasswordUpdated,
          );
          localStorage.setItem("userFirstName", response.firstName);
          localStorage.setItem("userLastName", response.lastName);
          localStorage.setItem("userEmail", response.email);
          localStorage.setItem("userType", response.userType);
          localStorage.setItem(
            "profileComplete",
            response.defaultPasswordUpdated,
          );
          localStorage.setItem("userUniqueId", response.uniqueId);
          localStorage.setItem("companyName", response.companyName);
          localStorage.setItem(
            "userCountry",
            response.countryDetail ? response.countryDetail.name : "",
          );
          localStorage.setItem("userIdForNotification", response.perId);

          if (response.preferredCurrency) {
            localStorage.setItem(
              "preferredCurrency",
              response.preferredCurrency.code,
            );
            localStorage.setItem(
              "preferredCurrencySymbol",
              response.preferredCurrency.symbol,
            );
          } else {
            localStorage.setItem("preferredCurrency", "JPY");
            localStorage.setItem("preferredCurrencySymbol", "¥");
          }
          PubSub.publish("ProfileStatus", "Yes");
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  };

  const renderSDEditForm = () => {
    setShowNewPasswordPopup(false);
    setIsEditProfile(true);
  };

  const onOpenPaddleModal = () => {
    setIsPaddle(true);
  };

  // Helper to handle the flow after Password reset/cancel
  const handlePasswordPopupClose = () => {
    setShowNewPasswordPopup(false);
    setIsEditProfile(false); // Explicitly ensure Edit Profile does not appear
    getProfile().then(() => {
      onOpenPaddleModal();
      const path = history.location.pathname.toLowerCase().replace(/\/$/, "");
      if (
        path === "/365products" ||
        path === "/365products/diamonds" ||
        path === "/365products/diamond"
      ) {
        handleComponents("DIAMODS");
      } else if (path === "/365products/jewellery") {
        handleComponents("JEWELLERY");
      }
    });
  };

  const handleComponents = (categoryType: String) => {
    if (categoryType === "DIAMODS") {
      annualCategoryAuction = "Diamonds";
      setShowJewelley(false);
      history.replace("/365products");
      dispatch(reSetJwlIsMybids());
    } else {
      annualCategoryAuction = "Jewellery";
      setShowJewelley(true);
      setIsLoading(true);
      dispatch(reSetIsMybids());
      history.replace("/365products/jewellery");
    }
    callApi();
  };

  const callApi = async () => {
    if (!oAuth()) {
      history.push("/");
    } else {
      setIsLoading(true);
      Auth.getRequest(advertisementUrl, (adStatus: number, adResponse: any) => {
        Auth.postRequest(
          `${annualAuctionJoinedCall}/${annualCategoryAuction}/join`,
          "",
          (status: any, response: any) => {
            if (status === 200) {
              if (response.category === "Diamonds") {
                dispatch(setAnnualAuctionData({ response }));
              } else {
                dispatch(setJwlAnnualAuctionData({ response }));
              }

              if (
                selectItemPerPageValue !== undefined &&
                selectItemPerPageValue !== "" &&
                adResponse?.results
              ) {
                const matchedData = adResponse.results.filter(
                  (item: any) => item.code === selectItemPerPageValue,
                );
                if (matchedData.length > 0) {
                  const { id } = matchedData[0];
                  const auctionId = response.perId;
                  const auctionUserId = response.auctionUserId;
                  const startDate = response.startDate;
                  const formattedDate = startDate
                    ? startDate.split("T")[0]
                    : "";
                  dispatch(resetParticipateProductId());
                  history.replace({
                    pathname: `/365products/details/${auctionId}/${auctionUserId}/${id}/${formattedDate}/${false}`,
                  });
                } else {
                  dispatch(resetParticipateProductId());
                }
              }
              joinAnnualAuction();
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          },
        );
      });
    }
  };

  const renderLoderspiner = () => (
    <div className="loading">
      <LoadingSpinner />
    </div>
  );

  return (
    <AppLayout {...props}>
      {isLoading ? (
        renderLoderspiner()
      ) : isShowJewelley ? (
        <JewelleryProductAuction
          {...props}
          setShowAlertMessage={setShowAlertMessage}
          setOpenToast={setOpenToast}
          setAlertType={setAlertType}
        />
      ) : (
        <DiamondProductAuction
          {...props}
          setShowAlertMessage={setShowAlertMessage}
          setOpenToast={setOpenToast}
          setAlertType={setAlertType}
        />
      )}

      {showNewPasswordPopup === true && (
        <StyledModal open={showNewPasswordPopup}>
          <NewPassword
            onClose={handlePasswordPopupClose}
            onShowPaddleNoModal={handlePasswordPopupClose}
            subDomainPage={handlePasswordPopupClose}
          />
        </StyledModal>
      )}

      {/* {isEditProfile && (
        <StyledModal
          open={isEditProfile}
          onClose={() => setIsEditProfile(false)}
          className="registerModal"
        >
          <SubdomainEditProfileForm
            {...profileData}
            {...props}
            closeModal={() => {
              setIsEditProfile(false);
              getProfile();
              onOpenPaddleModal();
            }}
            saveProfile={() => getProfile()}
            openPaddleModal={onOpenPaddleModal}
            timeZone={timeZone}
          />
        </StyledModal>
      )} */}
      {isPaddle && (
        <StyledModal open={isPaddle} onClose={() => setIsPaddle(false)}>
          <PaddleNumberModal
            closeModal={() => setIsPaddle(false)}
            paddleNumber={profileData?.paddleNumber}
          />
        </StyledModal>
      )}

      {openToast === true && (
        <Alert showAlertMessage={showAlertMessage} alertType={alertType} />
      )}
    </AppLayout>
  );
};

export default ProductAuctionContainer;
